<template>
    <div>
         <el-row>
            <el-col :lg="10" :offset="2">
               單品名稱: <el-tag type="info" effect="dark" style="font-size:18px;">{{this.getProductDetail.name}}</el-tag>
                
            </el-col>
            <el-col :lg="10" :offset="2">
                系列別名稱: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.className}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                品牌: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.brand_id == 1 ? 'N牌': 'S牌'}}</el-tag>
                
            </el-col>
            <el-col :lg="10" :offset="2">
                組合編號: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.id}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                特價品: {{this.getProductDetail.on_sale == true ? '是': '否'}}
            </el-col>
            <el-col :lg="10" :offset="2">
                折扣期限: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.on_sale_start}}</el-tag> - <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.on_sale_end}}</el-tag> 
            </el-col>
        </el-row>
             <el-row>
            <el-col :lg="10" :offset="2">
                <el-image
                  v-for="item in iges"
                    style="width: 150px; height: 150px;margin-right:20px;"
                    :src="item.url"
                    :preview-src-list="url"
                    fit="fill"
                    ></el-image>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
                <el-col :lg="22" :offset="2">
                    <el-table
                        :data="getProductDetail.products"
                        style="width: 100%">
                        <el-table-column
                            prop="id"
                            label="單品編號"
                            >
                        </el-table-column>
                        <el-table-column label="單品名稱" prop="name"></el-table-column>
                        <el-table-column label="價格" prop="price"></el-table-column>
                        <el-table-column label="單位" prop="spec">
                      
                        </el-table-column>
                        <el-table-column label="數量" prop="qty"></el-table-column>
                       
                    </el-table>
                </el-col>
            </el-row>
            <el-row>
            <el-col :lg="10" :offset="2">
                <el-button type="primary" @click="editTabs">編輯</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { async } from 'q'
import config from '@/store/config'
import axios from 'axios'
    export default {
        name: 'Bundle',
        props: {
            type: Number,
            productKey: String
        },
        data() {
            return {
                           productDetail: [],
                bundleDetail: [],
                className: '',
                images: [],
                iges: [],
                url: [],
                items: [],
            
            }
            },
               computed: mapGetters(["getProductDetail", "getClassList", "getImages"]),
            methods: {
            ...mapActions(["fetchProductDetail", "fetchClassList", "LoadFile" ]),
           async fetchProductDetail(){
                const data = await {type: this.type, _key:this.productKey}
                await this.$store.dispatch("fetchProductDetail", data)
                this.productDetail = await this.getProductDetail
                this.className = this.productDetail.class.name
                this.images = this.productDetail.images
              
               await this.fetchImage(this.images)
               
              },
           
           async fetchImage (images){
               for (let i = 0; i < images.length; i++) {
                   
                   const url = await  images[i].url
                 const res = await  axios({
                     method:'get',
                     url: config.BASE + url,
                     responseType: 'blob'
                 })
                     let src = await URL.createObjectURL(res.data)
                 await this.iges.push({
                      url:  src
                  })
                
                  this.url.push(
                      src
                  )
                   
               }
                  
           },
         
             
                  
                   
               
           
           async editTabs(){
               const data = await{type: this.type, key: this.productKey}
              await  this.$emit('editTabs', data)
              
           },
           async back(){
               await this.$emit('back')
           }
        },
          created() {
            this.fetchProductDetail()
            
        },
        
    }
</script>

<style lang="scss" scoped>
       .el-row {
      
        margin-bottom: 36px;
         font-weight: bold;
          font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
</style>